import { toDate, toNull, toUUID } from "shared/lib/zod/utils"
import { RoomTypename } from "shared/types/Project"
import { Room as GraphQLRoom } from "shared/types/__generated__/graphql"

import { RecursiveMinimalFloorWithParent } from "entities/floors/types/Floor"
import z from "zod"

export const ROOM_LABEL_MAX_LENGTH = 90
export const ROOM_NUMBER_MAX_LENGTH = 20

export const RoomSchema = z.object({
  id: z.string(),
  area: z.number().min(0).optional().nullish(),
  height: z.number().min(0).optional().nullish(),
  label: z.string().trim().max(ROOM_LABEL_MAX_LENGTH).optional().nullish(),
  number: z.string().trim().min(1).max(ROOM_NUMBER_MAX_LENGTH),
  personsNumber: z.number().min(0).optional().nullish(),
  position: z.number(),
  remark: z.string().optional().nullish(),
  sup: z.number().optional().nullish(),
  oda: z.number().optional().nullish(),
  eta: z.number().optional().nullish(),
  eha: z.number().optional().nullish(),
  tra: z.number().optional().nullish(),
  rca: z.number().optional().nullish(),
  ida: z.number().optional().nullish(),
  sec: z.number().optional().nullish(),
  airVolumePerArea: z.number().optional().nullish(),
  airVolumePerPerson: z.number().optional().nullish(),
  soundPressureLevel: z.number().optional().nullish(),
  utilization: z.string().optional().nullish(),
  volume: z.number().optional().nullish(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
  children: z.array(z.any()).optional().nullish(),
  parent: z.any().optional().nullish(),
  hasClarificationRequest: z.boolean().optional().nullish(),
  __typename: z
    .literal("Room")
    .optional()
    .transform(() => RoomTypename)
})

export const RoomSchemaTransform = RoomSchema.extend({
  id: RoomSchema.shape.id.transform(toUUID),
  area: RoomSchema.shape.area.transform(toNull),
  height: RoomSchema.shape.height.transform(toNull),
  label: RoomSchema.shape.label.transform(toNull),
  personsNumber: RoomSchema.shape.personsNumber.transform(toNull),
  remark: RoomSchema.shape.remark.transform(toNull),
  sup: RoomSchema.shape.sup.transform(toNull),
  oda: RoomSchema.shape.oda.transform(toNull),
  eta: RoomSchema.shape.eta.transform(toNull),
  eha: RoomSchema.shape.eha.transform(toNull),
  tra: RoomSchema.shape.tra.transform(toNull),
  rca: RoomSchema.shape.rca.transform(toNull),
  ida: RoomSchema.shape.ida.transform(toNull),
  sec: RoomSchema.shape.sec.transform(toNull),
  airVolumePerArea: RoomSchema.shape.airVolumePerArea.transform(toNull),
  airVolumePerPerson: RoomSchema.shape.airVolumePerPerson.transform(toNull),
  soundPressureLevel: RoomSchema.shape.soundPressureLevel.transform(toNull),
  utilization: RoomSchema.shape.utilization.transform(toNull),
  volume: RoomSchema.shape.volume.transform(toNull),
  createdAt: RoomSchema.shape.createdAt.transform(toDate),
  updatedAt: RoomSchema.shape.updatedAt.transform(toDate),
  children: RoomSchema.shape.children.transform(children => children ?? []),
  parent: RoomSchema.shape.parent.transform(toNull),
  hasClarificationRequest:
    RoomSchema.shape.hasClarificationRequest.transform(toNull)
})

export interface RoomUpdate extends Partial<GraphQLRoom> {
  id: string
}

export interface MinimalRoom {
  id: string
  number?: string | null | undefined
  label?: string | null | undefined
  __typename?: typeof RoomTypename
}

export interface RecursiveMinimalRoomWithParent extends MinimalRoom {
  parent: RecursiveMinimalFloorWithParent
}
